import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useContext, useMemo } from 'react';
import { LinkContext, FeatureFlagsContext } from '../../context';
import * as paths from './paths';
import { SiteFooter } from './site-footer';
import { WestfieldPlusContainer } from './westfield-plus-container';
import { LeftColumnContainer } from './left-column-container';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const getChildren = props => {
  if (props.taskMode) {
    return null;
  }

  const {
    Link,
    centre,
    country,
    onFindACentre
  } = props;
  return /*#__PURE__*/_jsxs(LinkContext.Provider, {
    value: _ref => {
      let props = Object.assign({}, _ref);
      return /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, props), {}, {
        "data-id": "universal-footer_index_getChildren_Link"
      }));
    },
    children: [/*#__PURE__*/_jsx(LeftColumnContainer, {
      centre: centre,
      country: country,
      onFindACentre: onFindACentre,
      "data-id": "universal-footer_index_getChildren_LeftColumnContainer"
    }), /*#__PURE__*/_jsx(WestfieldPlusContainer, {
      country: country,
      "data-id": "universal-footer_index_getChildren_WestfieldPlusContainer"
    })]
  });
};

export const UniversalFooter = props => {
  const isPersonalisedAdsEnabled = useContext(FeatureFlagsContext).NEXT_PUBLIC_FEAT_FLAG_PERSONALISED_ADS;
  const links = useMemo(() => [{
    label: 'Careers',
    href: paths.CAREERS
  }, {
    label: 'Leasing and Media',
    href: paths.LEASING_MEDIA
  }, {
    label: 'Responsible Business',
    href: paths.RESPONSIBLE_BUSINESS
  }, ...(isPersonalisedAdsEnabled ? [{
    label: 'Personalised Ads',
    href: paths.PERSONALISED_ADS
  }] : []), {
    label: 'Privacy Policy',
    href: paths.PRIVACY_POLICY
  }, {
    label: 'Terms and Conditions',
    href: paths.TERMS_CONDITIONS
  }], [isPersonalisedAdsEnabled]);
  return /*#__PURE__*/_jsx("div", {
    className: style.footerContainer,
    "data-id": "universal-footer_index_getChildren_div",
    children: /*#__PURE__*/_jsx(SiteFooter, {
      links: links,
      showAngle: false,
      country: props.country,
      "data-id": "universal-footer_index_getChildren_div_SiteFooter",
      children: getChildren(props)
    })
  });
};
UniversalFooter.displayName = 'UniversalFooter';